import type {TranslationModule} from '@hconnect/common/localization-loaders'

import {UIKIT_NAMESPACE} from '../consts'

export const uikitTranslations: TranslationModule = {
  namespace: UIKIT_NAMESPACE,
  resources: {
    'en-GB': () => import('./en_GB.json'),
    'en-US': () => import('./en_GB.json'),
    'cs-CZ': () => import('./cs_CZ.json'),
    'da-DK': () => import('./da_DK.json'),
    'de-DE': () => import('./de_DE.json'),
    'es-ES': () => import('./es_ES.json'),
    'fr-FR': () => import('./fr_FR.json'),
    'hu-HU': () => import('./hu_HU.json'),
    'it-IT': () => import('./it_IT.json'),
    'kk-KZ': () => import('./kk_KZ.json'),
    'nl-NL': () => import('./nl_NL.json'),
    'no-NO': () => import('./no_NO.json'),
    'pl-PL': () => import('./pl_PL.json'),
    'ro-RO': () => import('./ro_RO.json'),
    'ru-RU': () => import('./ru_RU.json'),
    'sv-SE': () => import('./sv_SE.json'),
    'th-TH': () => import('./th_TH.json')
  }
}
